import { render, staticRenderFns } from "./StepView.vue?vue&type=template&id=3b6480c3&scoped=true&"
import script from "./StepView.vue?vue&type=script&lang=js&"
export * from "./StepView.vue?vue&type=script&lang=js&"
import style0 from "./StepView.vue?vue&type=style&index=0&id=3b6480c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6480c3",
  null
  
)

export default component.exports